(function () {
    'use strict';

    angular
        .module('oddPublicModule', [])
        .directive('oddComponent', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                component: '='
            },
            restrict: 'AE',
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', '$q', function ($scope, $q) {

                $scope.campaign = {answerByQuestionID: [], followUpsByQuestionID: []};
                $scope.componentCtxt = {
                    isInPreview: true
                };
                $scope.campaignContext = {
                    _hasStartedRequest: function(){},
                    _hasFinishedRequest: function(){}
                };

                $scope.component._isVisible = true;

                $scope.getTemplateUrl = function () {
                    if ($scope.component.ItemTypeCode === 'ODDStaticText') {
                        return '/app/shared/odd/oddPublic/oddComponent.StaticText.Default.tpl.html';
                    }

                    return '/app/shared/odd/oddPublic/oddComponent.' +
                        $scope.component.ODDQuestionType.CategoryCode + '.' +
                        $scope.component.ODDQuestionType.CategoryBehaviour + '.tpl.html';
                };

                if ($scope.component.hasOwnProperty('ConditionalQuestionID')) {
                    $scope.componentCtxt.triggerQuestion = {_isVisible: true};
                }

                /**
                 * In preview-mode, answers are not saved
                 * @returns fake resolved promise
                 */
                $scope.saveAnswer = function () {
                    return $q(function(resolve) {
                        resolve(null);
                    });
                };

                $scope.submitForReview = function () {
                    void(0);
                };

                $scope.getAttributeValue = function (attributeCode) {
                    var attr = _.find($scope.component.ODDQuestionAttributeValues, {Code: attributeCode});
                    return attr && attr.ValueText;
                };


                /** === Attachments === */

                $scope.getDownloadAttachmentUrl = function () {
                    void (0);
                };

                $scope.uploadAttachments = function () {
                    void (0);
                };

                $scope.deleteAttachment = function () {
                    void (0);
                };

                $scope.validateAttachmentUniqueName = function () {
                    voir (0);
                };

                $scope.addAttachmentFileName = function () {
                    voir (0);
                }

            }],
            link: function (scope) {
                scope.layoutRatio = {column: 'col-sm-12'};
            }
        };
    }
})();